import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  OnDestroy,
  NgZone,
} from "@angular/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import { FullCalendarComponent } from "@fullcalendar/angular";
import timeGrid from "@fullcalendar/timegrid";
import { AppService } from "../services/app.service";
import { chkLength as chkLengthUtil } from "../utils/format-util";
import { EventInput, Calendar } from "@fullcalendar/core";
import { SupportService } from "../services/support-service";
import { ScheduleSharedService } from "../services/schedule-shared.service";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import * as moment from "moment";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";
import { NgxUiLoaderService } from "ngx-ui-loader";

const days: any = [
  { id: 1, name: "monDay", value: "Monday", key: "Mon" },
  { id: 2, name: "tueDay", value: "Tuesday", key: "Tue" },
  { id: 3, name: "wedDay", value: "Wednesday", key: "Wed" },
  { id: 4, name: "thuDay", value: "Thursday", key: "Thu" },
  { id: 5, name: "friDay", value: "Friday", key: "Fri" },
  { id: 6, name: "satDay", value: "Saturday", key: "Sat" },
  { id: 0, name: "sunDay", value: "Sunday", key: "Sun" },
];
@Component({
  selector: "app-technician-schedule",
  templateUrl: "./technician-schedule.component.html",
  styleUrls: ["./technician-schedule.component.scss"],
})
export class TechnicianScheduleComponent implements OnInit, OnDestroy {
  // @ViewChild('calendar') calendarComponent: FullCalendarComponent; // the #calendar in the template
  // calendarPlugins = [ timeGrid ];
  today: any = new Date();
  eventApiData: any;
  equipmentData: any;
  equipmentDataList = [];
  // eventCalenderData: EventInput[] = [];
  patientID = "";
  patientName = "";
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  isModel = false;
  patientDetails: any = {};
  mintime = "08:00";
  maxTime = "19:59";
  workingHours: any = [];
  calender;
  viewTitle = "";
  technicianList = [];
  selectedTechnicianId = "";
  selectedName = "";
  viewType = "day";
  calendarView = "resourceTimeGridDay";
  @ViewChild("PatientModal") PatientModal: TemplateRef<any>;
  isworking = false;
  isResource = false;
  calendarResourceList: any = [];
  tcCountryCode = "";

  constructor(
    private appservice: AppService,
    private ngxService: NgxUiLoaderService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private zone: NgZone,
    private modalService: BsModalService,
    private supportService: SupportService,
    private scheduleShared: ScheduleSharedService
  ) {
    this.scheduleShared.registerAngularComponentRef(this);
  }

  navigate(val) {
    const res = val.split("/");
    if (res.length > 0) {
      if (res[1] === "patient") {
        this.patientID = res[2];
        this.patientName = res[3];

        setTimeout(() => {
          if (this.isModel === false) {
            this.patientID = res[2];
            this.patientName = res[3];
            this.appservice
              .viewscheduleappointmentpro(this.patientID)
              .subscribe((scheduleDetail: any) => {
                if (scheduleDetail.status.status === 200) {
                  this.patientDetails = {};
                  this.patientDetails.mobile =
                    scheduleDetail.entity.schedule.patientPhoneCode +
                    " " +
                    scheduleDetail.entity.schedule.patientPhone;
                  this.patientDetails.scheduledOn =
                    scheduleDetail.entity.schedule.scheduledOn;
                  this.patientDetails.scheduleFromTime =
                    scheduleDetail.entity.schedule.scheduleFromTime;
                  this.patientDetails.scheduleToTime =
                    scheduleDetail.entity.schedule.scheduleToTime;
                  this.patientDetails.insuranceType =
                    scheduleDetail.entity.schedule.insuranceType;
                  this.patientDetails.insuranceName =
                    scheduleDetail.entity.schedule.insuranceName;
                  this.patientDetails.physicianFirstName =
                    scheduleDetail.entity.schedule.physicianFirstName;
                  this.patientDetails.physicianLastName =
                    scheduleDetail.entity.schedule.physicianLastName;
                  if (scheduleDetail.entity.procedures.length > 0) {
                    this.patientDetails.bodyPartName =
                      scheduleDetail.entity.procedures[0].bodyPartName;
                    this.patientDetails.procedureName =
                      scheduleDetail.entity.procedures[0].procedureName;
                  }
                  if (scheduleDetail.entity.schedProEquips.length > 0) {
                    this.patientDetails.technicianFirstName =
                      scheduleDetail.entity.schedProEquips[0].technicianFirstName;
                    this.patientDetails.technicianLastName =
                      scheduleDetail.entity.schedProEquips[0].technicianLastName;
                  }
                  this.patientDetails.patientFirstName =
                    scheduleDetail.entity.schedule.patientFirstName;
                  this.patientDetails.patientLastName =
                    scheduleDetail.entity.schedule.patientLastName;
                  setTimeout(() => {
                    if (this.modalService.getModalsCount() === 0) {
                      this.openModal(this.PatientModal);
                    }
                  }, 252);
                }
              });
          }
        }, 252);
      } else {
        this.zone.run(() => {
          this.isModel = true;
          this.router.navigate([val]);
        });
      }
    }
  }

  ngOnInit() {
    this.ngxService.start();

    setTimeout(() => {
      this.ngxService.stopAll();
    }, 1500);

    this.getResourceList();
    this.getAllTechniciansByTestCenterId();
  }

  getAllTechniciansByTestCenterId() {
    const data = {
      testcenterId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
      sortColumn: "firstName",
      sortType: "asc",
    };
    this.appservice.getAllTechnicianByTcId(data).subscribe((res: any) => {
      if (res && res.status.status === 200) {
        this.technicianList = res.entity;
        if (this.technicianList.length > 0) {
          this.technicianList.forEach((techData) => {
            techData.username = techData.firstName + " " + techData.lastName;
          });
        }
      }
    });
  }

  onSelect(event: TypeaheadMatch): void {
    this.selectedTechnicianId = event.item.id;
    this.getEventDayDate();
  }

  clearSearch() {
    this.selectedName = "";
    this.selectedTechnicianId = "";
    this.getEventDayDate();
  }

  gotoLeft() {
    if (this.calender) {
      this.calender.prev();
      this.today = this.calender.getDate();
      this.viewTitle = this.calender.view.title;
      this.getEventDayDate();
    }
  }

  gotoRight() {
    if (this.calender) {
      this.calender.next();
      this.viewTitle = this.calender.view.title;
      this.today = this.calender.getDate();
      this.getEventDayDate();
    }
  }

  getMonthNumberBymonthName(valuearray): string {
    return this.scheduleShared.getMonthNumberBymonthName(valuearray);
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }

  viewTestCenter() {
    this.appservice
    .checkGivenDateIsHolidayOrNot(
      this.formatHomeDate(this.today)
    )
    .subscribe((res) => this.scheduleShared.applyHolidayCheckResult(this, res));
  }

  setCalendarTime(work) {
    this.scheduleShared.setCalendarTime(this, days, work);
  }

  closeModal() {
    this.modalRef.hide();
    this.isModel = false;
  }

  calenderView() {
    const calendarEl = document.getElementById("tech-calendar");
    calendarEl.innerHTML = "";
    const calender = new Calendar(calendarEl, {
      schedulerLicenseKey: "0569894629-fcs-1563784117",

      plugins: [resourceTimeGridPlugin, dayGridPlugin],
      defaultView: this.calendarView,
      // weekNumbers: true,
      // timeZone: 'local',
      timeZone: "UTC",
      allDaySlot: false,
      // events: this.eventCalenderData,
      resources: this.equipmentDataList,
      // eventClick: this.eventChanges,
      eventRender: this.eventChange,
      // header: false,
      minTime: this.mintime,
      maxTime: this.maxTime,
      header: false,
      // weekends: false,
      // hiddenDays: []
      // header: {
      //   left: ' today myCustomButton',
      //   center: 'title',
      //   right: 'resourceTimeGridDay,dayGridWeek,dayGridMonth'
      // },
    });
    calender.gotoDate(this.today);
    calender.render();
    return calender;
  }
  
  eventChange(event) {
    const element = event.el as HTMLElement;
    const tcID = localStorage.getItem("testCode");
    if (event.event.extendedProps.customId) {
      if (event.view.type === "dayGridMonth") {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title"  onclick='angularComponentRef.componentFn
        (\"/patient/${event.event.extendedProps.customId}/${event.event.extendedProps.patientFirstName} ${event.event.extendedProps.patientLastName}\")'
        ondblclick='angularComponentRef.componentFn
        (\"/${tcID}/check-in-patient/${event.event.extendedProps.customId}\")'>
        ${event.event.extendedProps.patientFirstName}  ${event.event.extendedProps.patientLastName}
        <br/> ${event.event.extendedProps.eventStartTime} - ${event.event.extendedProps.eventEndTime}
        </div>
        </div>
        `;
      } else {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title"  onclick='angularComponentRef.componentFn
        (\"/patient/${event.event.extendedProps.customId}/${
          event.event.extendedProps.patientFirstName
        } ${event.event.extendedProps.patientLastName}\")'
        ondblclick='angularComponentRef.componentFn
        (\"/${tcID}/check-in-patient/${event.event.extendedProps.customId}\")'>
        ${event.event.extendedProps.patientFirstName}  ${
          event.event.extendedProps.patientLastName
        }
        ${
          event.event.extendedProps.procedureName
            ? " <br/>" + event.event.extendedProps.procedureName
            : ""
        }
        <br/> ${event.event.extendedProps.eventStartTime} - ${
          event.event.extendedProps.eventEndTime
        }
        </div>
        </div>
        `;
      }
    } else {
      // console.log(event);
      if (event.event.title === "Lunch") {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title">
        Lunch  <br/>
        ${event.event.extendedProps.eventStartTime} ${event.event.extendedProps.eventEndTime}
        </div>
        </div>
        `;
      } else if (event.event.title === "Closed" || event.event.title === "Holiday" || event.event.title === "Weekoff") {
        element.innerHTML = `
        <div class="fc-content" >
        <div class="fc-title">
        Closed
        </div>
        </div>
        `;
      }
    }
  }

  getToday() {
    this.today = new Date();
    this.viewType = "day";
    this.calendarView = "resourceTimeGridDay";
    this.supportService.getDateChange.next({ date: true });
    this.getEventDayDate();
  }

  openModal(template: TemplateRef<any>) {
    this.PatientModal.createEmbeddedView(null);
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
    setTimeout(() => {
      const element: HTMLElement = document.getElementById("click-modal");
      element.click();
    }, 252);
  }

  gotoPage(page) {
    this.patientID = localStorage.getItem("patientID");
    localStorage.removeItem("patientID");
    if (this.patientID) {
      console.log(this.patientID);
      const tcID = localStorage.getItem("testCode");
      this.router.navigateByUrl(`/${tcID}/${page}/${this.patientID}`);
    }
  }

  private buildScheduleEvent(event, obj) {
    event.customId = obj.scheduleAppointmentId;
    event.resourceId = obj.equipmentMac;
    event.title =
      obj.examShortname +
      " - " +
      obj.bodyPart +
      " - " +
      obj.procedureName;
    event.start = obj.scheduledOnStr + "T" + obj.fromTime + "+00:00";
    event.end = obj.scheduledOnStr + "T" + obj.toTime + "+00:00";
    event.eventStartTime = obj.scheduleFromTime;
    event.eventEndTime = obj.scheduleToTime;
    event.procedureName = obj.procedureName;
    obj.technicianFirstName
      ? (event.patientFirstName = obj.technicianFirstName)
      : (event.patientFirstName = "");
    obj.technicianLastName
      ? (event.patientLastName = obj.technicianLastName)
      : (event.patientLastName = "");
    event.patientId = obj.patientId;
    event.textColor = "white";
  }

  getEventDayDate() {
    const data = {
      startDate: this.formatHomeDate(this.today),
      type: this.viewType,
    };
    this.appservice.gettcschedulebydatetype(data).subscribe((res) => {
      this.eventApiData = res;
      this.eventApiData = this.eventApiData.entity;
      const calender = this.calenderView();
      if (this.eventApiData) {
        if (this.eventApiData.length > 0) {
          const eventList: any = [];
          this.eventApiData.forEach((obj) => {
            const event: any = {};
            if (this.selectedTechnicianId) {
              if (obj.technicianId === this.selectedTechnicianId) {
                this.buildScheduleEvent(event, obj);
              }
            } else {
              this.buildScheduleEvent(event, obj);
            }
            eventList.push(event);
          });
          calender.addEventSource(eventList);
        }
      }

      this.calender = calender;
      this.viewTitle = this.calender.view.title;
      this.viewTestCenter();
    });
  }

  getResourceList() {
    if (this.isResource === false) {
      const tcID = localStorage.getItem("testCenterId");
      const data1 = {
        testCenterId: tcID,
      };
      this.appservice.getAllEquipmentsByTc(data1).subscribe(
        (res) => {
          this.equipmentData = res;
          this.equipmentData = this.equipmentData.entity;
          this.equipmentData.forEach((obj) => {
            this.equipmentDataList.push({ id: obj.mac, title: obj.mac });
          });
          this.isResource = true;
          this.getEventDayDate();
        },
        (err) => {
          if (err.error.error === "invalid_token") {
            this.appservice.sessionOut(err);
          }
        }
      );
    } else {
      this.getEventDayDate();
    }
  }

  formatHomeDate(date) {
    return this.scheduleShared.formatHomeDate(date);
  }

  getInsurance(type) {
    return this.scheduleShared.getInsurance(type);
  }

  viewChange(type) {
    if (this.calender) {
      console.log(type);
      if (type === "resourceTimeGridDay") {
        this.viewType = "day";
      }
      if (type === "dayGridWeek") {
        this.viewType = "week";
      }
      if (type === "dayGridMonth") {
        this.viewType = "month";
      }
      this.calender.changeView(type);
      this.calendarView = type;
      this.today = this.calender.getDate();
      this.getEventDayDate();
    }
  }

  convertTime12to24 = (time12h) =>
    this.scheduleShared.convertTime12to24(time12h);

  ngOnDestroy() {
    this.cd.detach();
    if (this.calender) {
      this.calender.destroy();
    }
  }
}
